export default "__VITE_ASSET__CTdJsuwt__"